// extracted by mini-css-extract-plugin
export default {"tabList":"hvn0RtMse-OtdGG+5YXvgBZCYY88AwBP8U7aWoauTWo="};